// extracted by mini-css-extract-plugin
export default {"root":"growth-model_root__K-7Ft"};